module.exports = __webpack_public_path__ + "hero.570bb9314e20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/about/hero.jpg
// module id = ./src/styles/marketing/about/hero.jpg
// module chunks = 21